import {
  Card,
  Col,
  Form,
  Input,
  Row,
  Typography,
} from "antd";
import React from "react";
const { Title } = Typography;

const RequesterInformation = ({ getChildData }) => {

  const validatePhone = (_, value) => {
    // Example regex for phone number validation (adjust as needed)
    const phoneRegex = /^[+]?[0-9]{10,15}$/;
    if (!value || phoneRegex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("Please enter a valid phone number."));
  };

  const callparent = (value, name) => {
    getChildData(value, name);
  };
  return (
    <Card
      styles={{ body: { padding: 0 }, header: { marginBottom: 20 } }}
      bordered={false}
      size="0"
      title={
        <Title
          className="font-semibold"
          style={{ marginBottom: "0" }}
          level={4}
        >
          Requester Information
        </Title>
      }
    >
      <Row gutter={[20, 0]} className="px-2 md:px-6">
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            label="First Name/Organization"
            name="nameorganization"
            onChange={(e) => callparent(e.target.value, "RequesterName")}
            rules={[
              {
                max: 50,
                required: true,
                message: "Please enter first name or organization.",
              },
            ]}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            label="Last Name"
            onChange={(e) => callparent(e.target.value, "RequesterLastName")}
            name="RequesterLastName"
            rules={[
              { required: true, max: 50, message: "Please enter last name." },
            ]}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            label="Email"
            onChange={(e) => callparent(e.target.value, "RequesterEmail")}
            name="email"
            rules={[
              { required: true, max: 100, message: "Please enter email." },
              {
                type: "email",
                message: "Please enter valid email.",
              },
            ]}
          >
            <Input maxLength={100} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            label="Phone Number"
            name="phone"
            onChange={(e) => callparent(e.target.value, "RequesterPhoneNumber")}
            rules={[
              { required: true, max: 20, message: "Please enter phone number." },
              { validator: validatePhone },
            ]}
          >
            <Input maxLength={20} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            name="address1"
            label="Address Line 1"
            onChange={(e) => callparent(e.target.value, "RequesterAddLine1")}
            rules={[{ required: true, max: 150, message: "Please enter address." }]}
          >
            <Input maxLength={150} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            name="address2"
            onChange={(e) => callparent(e.target.value, "RequesterAddLine2")}
            label="Address Line 2"
          >
            <Input maxLength={150} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="city"
            label="City"
            onChange={(e) => callparent(e.target.value, "RequesterCity")}
            rules={[{ required: true, max: 50, message: "Please enter city name." }]}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="state"
            label="State"
            onChange={(e) => callparent(e.target.value, "RequesterState")}
            rules={[{ required: true, max: 50, message: "Please enter state name." }]}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="zipcode"
            label="Zip Code"
            onChange={(e) => callparent(e.target.value, "RequesterZipCode")}
            required
            rules={[
              {
                max: 8,
                required: true,
                message: "Please enter ZIP code.",
              },
              {
                pattern: /^[0-9]+$/, // Ensure only numeric characters
                message: "ZIP code must be numeric.",
              },
              {
                min: 5, // Minimum length of 5 characters
                message: "ZIP code must be at least 5 digits long.",
              },
            ]}
          >
            <Input maxLength={8} />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};

export default RequesterInformation;
